<template>
    <div
        :class="themeClass"
        class="slds-progress-ring"
    >
        <div
            :aria-valuenow="percentStored"
            class="slds-progress-ring__progress"
            role="progressbar"
            aria-valuemin="0"
            aria-valuemax="100"
        >
            <svg viewBox="-1 -1 2 2">
                <path
                    id="slds-progress-ring-path-2"
                    :d="progress"
                    class="slds-progress-ring__path"
                />
            </svg>
        </div>
        <div class="slds-progress-ring__content">
            <slot>
                <template v-if="showPercent">
                    {{ Math.floor(percentStored) }}
                </template>
                <template v-else-if="showStep">
                    <MAIconInline
                        v-if="isComplete"
                        :svg="require('!html-loader!@salesforce-ux/design-system/assets/icons/utility/check.svg')"
                        class="slds-icon_container slds-icon-utility-check"
                        iconClass="slds-icon"
                        assistiveText="Complete"
                    />
                    <span v-else>{{ step }}</span>
                </template>
            </slot>
        </div>
    </div>
</template>

<script>
    import MAIconInline from './ma-icon-inline';

    export default {
        components: { MAIconInline },
        props: {
            percent: {
                type: Number,
                default: 0,
                validate: () => this.percent <= 100
            },
            large: {
                type: Boolean,
                default: false
            },
            theme: {
                type: String,
                default: ''
            },
            showPercent: {
                type: Boolean,
                default: false
            },
            showStep: {
                type: Boolean,
                default: false
            },
            step: {
                type: Number,
                default: 0
            },
            isComplete: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                percentStored: 0
            };
        },
        computed: {
            progress() {
                const arcX = Math.cos(2 * Math.PI * (this.percentStored / 100));
                const arcY = Math.sin(2 * Math.PI * (this.percentStored / 100));
                const isLong = this.percentStored < 50 ? 0 : 1;
                const progressRingAttribute = `M 1 0 A 1 1 0 ${isLong} 1 ${arcX} ${arcY} L 0 0`;

                return progressRingAttribute;
            },
            themeClass() {
                return {
                    'slds-progress-ring_large': this.large,
                    'slds-progress-ring_complete': this.isComplete,
                    'slds-progress-ring_warning': this.theme === 'warning',
                    'slds-progress-ring_expired': this.theme === 'expired',
                    'slds-progress-ring_active-step': this.theme === 'active'
                };
            }
        },
        watch: {
            percent: {
                handler(value) {
                    if (value > 100) {
                        value = 100;
                    } else if (value < 0) {
                        value = 0;
                    }
                    this.percentStored = value;
                },
                immediate: true
            }
        }
    };
</script>

<style scoped lang="scss">
    .slds-progress-ring_complete {
        background-color: #4bca81;
    }

    .slds-progress-ring__content {
        font-size: .5rem;
        font-weight: 700;
        color: #3e3e3c;
    }

    .slds-progress-ring_large {
        height: 2rem;
        width: 2rem;

        .slds-progress-ring__content {
            font-size: .8125rem;
        }
    }
</style>
